import React from "react"
import { Dispatch } from "redux"

import { PENDING } from "const"
import { MtDriveFolder } from "server/models"
import { replaceHistoryState } from "client/utils"
import {
    DriveFolder,
    UserData,
    LoadProjectFolderAccessData,

    setDrivePath,
    setDriveFolderListLoadState,
    setDriveFolderList,
    setDriveFileList,
    addModal,

    createDriveUrl,
    clearDriveSelection,
} from "client/store"

import FileEdit from "client/pages/drive/fileEdit"

export const OpenFolder = (
    folder: DriveFolder,
    userData: UserData,
    onSelect: any,
    dispatch: Dispatch,
) => {
    dispatch(setDriveFolderList([]))
    dispatch(setDriveFileList([]))
    clearDriveSelection(dispatch)

    if (!onSelect) replaceHistoryState(folder.url)

    if (!folder.project) {
        dispatch(setDrivePath(folder.path))
    } else {
        // load project data to define access to the folder
        dispatch(setDriveFolderListLoadState(PENDING))
        LoadProjectFolderAccessData(folder.project.id, userData, dispatch)
        .then(() => {
            dispatch(setDrivePath(folder.path))
        })
    }
}

export const OpenFile = (
    fileId: number,
    fileUrl: string | null,
    drivePath: readonly MtDriveFolder[],
    baseRoute: string,
    onSelect: any,
    dispatch: Dispatch,
) => {
    if (fileUrl && !onSelect) replaceHistoryState(fileUrl) // we don't need to update url when the file is opened by path on page load
    dispatch(addModal({
        key: "viewFile",
        content: <FileEdit fileId={fileId} />,
        onClose: () => {
            const url = createDriveUrl(drivePath, baseRoute)
            if (!onSelect) replaceHistoryState(url)
            clearDriveSelection(dispatch)
        },
    }))
}
